module.exports = __webpack_public_path__ + "img/device_on.82706a35.svg";